import styled from 'styled-components'

export const SvgContainer = styled.div`
  grid-column: 1 / span 3;
`

export const Svg = styled.div``
